// @flow strict

import { createContext } from 'react';
import type { HeroTransitionDirection } from '../../styled-components/Hero/HeroTransitionDirection';

export default createContext<?HeroTransitionDirection>(null);
